module.exports = __webpack_public_path__ + "img/jing7.7188aadc.jpg";